import { RootState } from '@redux/types';

export const colorsSelector = (state: RootState) => state.colorPalette.colors;
